export default __webpack_public_path__ + "static/media/AUTOMOVILES_IMG.5f36a693.jpg";